var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.79,
    height: 18.524,
    viewBox: "0 0 19.79 18.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "X",
    d: "M2.592,1.275H5.3L17.245,17.249H14.539ZM17.145,0l-6.2,6.7L5.936,0H.047L7.688,10.217,0,18.524H1.73l6.732-7.273L13.9,18.524H19.79L11.718,7.732,18.874,0Z",
    fill: "#fcbf49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcode);
export default __webpack_public_path__ + "static/media/xcode.fa709a66026bbb4f26f38d33af3149d9.svg";
export { ForwardRef as ReactComponent };